module.exports = __webpack_public_path__ + "img/CXQAUSLogo - Lite.6ef7e198.png";